export function listAthlete(params) {
    return window.axios.post("api/athlete/list", params)
}

export function deleteAthlete(id) {
    return window.axios.post("api/athlete/delete", { id: id })
}
export function batchDeleteAthlete(id) {
    return window.axios.post("api/athlete/batchDelete", { ids: id })
}

export function updateAthlete(params) {
    return window.axios.post("api/athlete/update", params)
}

export function clearAthlete(params) {
    return window.axios.post("api/athlete/clear", params)
}

export function addAthlete(params) {
    return window.axios.post("api/athlete/add", params)
}

export function getAthlete(id) {
    return window.axios.post("api/athlete/get", { id: id })
}

export function exportAthlete(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/athlete/export/excel", params, config)
}

export function getTeamStatistics(params) {
    return window.axios.post("api/athlete/getTeamStatistics", params)
}

export function exportTeamStatistics(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/athlete/exportTeamStatistics", params, config)
}

export function exportTeamStatisticsConfig() {
    return window.axios.post("api/athlete/exportTeamStatisticsConfig", {})
}

export function exportAthleteConfig() {
    return window.axios.post("api/athlete/exportConfig", {})
}

export function getTeamStatisticsInfo(params) {
    return window.axios.post("api/athlete/getTeamStatisticsInfo", params)
}

export function exportTeamStatisticsInfo(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/athlete/exportTeamStatisticsInfo", params, config)
}
